/**
 * ChatWelcome — 聊天欢迎页组件
 *
 * 功能：
 * - 显示 AI 助手介绍
 * - 快捷建议按钮列表（点击直接发送对应消息）
 * - 无消息时作为消息列表的默认展示
 */

import React from 'react';
import { BotIcon } from '../Icons';
import './index.scss';

interface ChatWelcomeProps {
  /** 快捷建议文本列表 */
  suggestions: string[];
  /** 点击建议或输入的回调 */
  onSend: (text: string) => void;
  /** 是否禁用（正在加载中） */
  disabled?: boolean;
}

/**
 * 聊天欢迎页组件
 */
const ChatWelcome: React.FC<ChatWelcomeProps> = ({
  suggestions,
  onSend,
  disabled = false,
}) => {
  return (
    <div className="chat-welcome">
      {/* AI 助手图标 */}
      <div className="chat-welcome-icon">
        <BotIcon />
      </div>

      {/* 标题 */}
      <h2>你好，我是阿呆 AI 助手</h2>
      <p>我可以帮你解答技术问题、编写代码、分析文章等</p>

      {/* 快捷建议按钮 */}
      <div className="chat-suggestions">
        {suggestions.map((text) => (
          <button
            key={text}
            className="chat-suggestion-item"
            onClick={() => onSend(text)}
            disabled={disabled}
          >
            {text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChatWelcome;
